import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2a10 10 0 110 20 10 10 0 010-20zm0 18a8 8 0 100-16 8 8 0 000 16z"/>
    <path fill="#34CEFF" d="M16 11h-4V8l-4 4 4 4v-3h4v-2z"/>
  </SvgIcon>
);